import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';
import Skeleton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Skeleton';

const styles = (theme) => ({
  root: {
    minWidth: 275,
    width: 275,
    height: 465,
    borderRadius: theme.radius.md,
    overflow: 'hidden',
  },
});

const CuratedContentCarouselCardSkeleton = ({
  classes,
  className,
}) => {
  return (
    <Skeleton variant="rect" className={classNames(classes.root, className)} />
  );
};

CuratedContentCarouselCardSkeleton.defaultProps = {
  className: '',
};

CuratedContentCarouselCardSkeleton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CuratedContentCarouselCardSkeleton);
